module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/direction-icon-C-doubled.b770bbbd.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/direction-icon-C-doubled.png
// module id = 2514
// module chunks = 11